import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

const UserProfileMenuButton = () =>
  import(/* webpackChunkName: "4-feat-userprofile-menubutton" */ './UserProfileMenuButton');

const LoadableUserProfileMenuButton: ComponentType = lazyLoadOnRender({ loader: UserProfileMenuButton });
export default LoadableUserProfileMenuButton;
